module.exports = __webpack_public_path__ + "img/mini-capsule-img.bf9f21b1.png";